import React from 'react';
import {injectIntl, defineMessages} from "react-intl";
import Image from './image.js';
import Menu from './menu.js';
import * as Icons from './icons.js';
import {reisy, use} from 'reisy';
import Flow from "../publishables/flow.js";
import PropTypes from 'prop-types';
import Link from "../components/link.js";
import Navigation from "../navigation/index.js";
import Heading from './heading';

export const styles = reisy`
@namespace Footer;

show: true;
showLogo: true;
showName: true;
showCopyright: true;
showCurrentYear: true;
htmlCopyright: false;
Branding: $Settings.Branding;
FooterBleed: $Settings.FooterBleed;
layout: loose;

ForegroundColor: $Colors.TextLight;
ForegroundSecondaryColor: $Colors.TextSubtle;

navbarCollapsed: none;
navbarExpanded: none;
navbarBehavior: static;

footer {
	@extends Helpers.FontSize, Typography.Footer;
	position: relative;
	background: linear-gradient(#212121, #2F2F2F);
	padding: 1em 2em;
	text-align: center;
	width: 100%;
	margin: 0 auto;

	&, & *, & *::after, & *::before {
		box-sizing: border-box;
	}
}

footerNoBleed {
	max-width: $Settings.KoskMaxWidth;
}

innerWrap {
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: $Settings.KoskMaxWidth;
	margin: 0 auto;

	a {
		color: $Footer.ForegroundSecondaryColor;
		text-decoration: none;
		&:hover {
			text-decoration: underline;
		}
	}
}

section {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 2em 0;
	&:last-child {
		margin: 0;
	}
}
sectionHeading {
	@extends Typography.FooterHeading;
	margin: .5em 0 0;
}
sectionList {
	padding: 0;
	margin-top: 1em;
	list-style-type: none;
}
sectionListItem {
	display: inline-block;
	padding-left: 1em;
	font-family: $Fonts.aside;
	&:first-child {
		padding: 0;
	}
}
sectionListSeparator {
	display: block;
	padding-top: 1em;
	color: $Footer.ForegroundSecondaryColor;
	&:first-child {
		padding: 0;
	}
	& + li {
		padding-left: 0;
	}
}
publisherLogo {
	img {
		max-height: 3em;
		margin: 0 auto;
	}
}
publisherLogoUser {
	img {
		border-radius: 50%;
	}
}
sectionPagestrip {
	font-size: .75em;
	a {
		color: $Footer.ForegroundSecondaryColor;
	}
}
sectionPagestripList {
	margin-bottom: .5em;
}
pagestripIcon {
	width: 1.75em;
	height: 1.75em;
}
copyright {
	@extends Typography.FooterCopyright;
	margin-top: .5em;
	text-align: center;
}
`;

const Footer = ({publisher, intl}) => {
	if (!styles.show) {
		return null;
	}
	const currentYear = styles.showCurrentYear != false ? new Date().getFullYear() : "";
	const messages = defineMessages({
		copyright: {
			id: "footer.copyright",
			defaultMessage: publisher.name,
		},
	});
	return (
		<footer {...use(styles.footer, !styles.FooterBleed && styles.footerNoBleed)}>
			<div {...use(styles.innerWrap)}>
				{publisher.positions && publisher.positions.footer && publisher.positions.footer.length
					? Flow(styles.layout, intl.formatMessage, publisher.positions.footer)
					: null
				}

				<div {...use(styles.section)}>
					{styles.showLogo && publisher.image
						? <Link
							mode="native"
							to={{context: publisher.id, absolute: '/', hierarchy: [], query: {}}}>
							<Image style={[styles.publisherLogo, publisher.type === 'user' ? styles.publisherLogoUser : null]} image={publisher.image} lazy name="fitted" availWidth={300} />
						</Link>
						: null
					}
					{styles.showName ? <Link
						mode="native"
						to={{context: publisher.id, absolute: '/', hierarchy: [], query: {}}}>
						<Heading lvl={3} {...use(styles.sectionHeading)}>{publisher.name}</Heading>
					</Link>
						: null}
					<Menu position="footer" menues={publisher.menues} />
					<Navigation styles={styles} />
				</div>

				{styles.Branding
					? <div {...use(styles.section, styles.sectionPagestrip)}>
						<a href="https://pagestrip.com/">
							<Icons.Logo {...use(styles.pagestripIcon)} />
						</a>
						<Menu position="psFooter" menues={publisher.menues} />
						{styles.showCopyright ? <p {...use(styles.copyright)}>&copy;{currentYear} alice interactive</p> : null}
					</div>
					: styles.showCopyright ? (
						styles.htmlCopyright ? <p {...use(styles.copyright)} dangerouslySetInnerHTML={{__html: `&copy;${currentYear} ${intl.formatMessage(messages.copyright)}`}}></p> 
						: <p {...use(styles.copyright)}>&copy;{currentYear} {intl.formatMessage(messages.copyright)}</p> 
					) : null
				}
			</div>
		</footer>
	);
};

Footer.propTypes = {
	intl: PropTypes.object,
	publisher: PropTypes.object,
};

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./lib/components/footer.js